import styled from '@emotion/styled'
import { StyledKicker } from '../../../../cards/Kicker/Kicker.styled'
import { IconPlay } from '../../../../icons/IconPlay/IconPlay'
import { StyledLiveBubble } from '../../../../typography/EditorialLabel/EditorialLabel.styled'
import { themedValue } from '../../../../__styling'
import { colors } from '../../../../__styling/settings/colors'
import { breakpointMax } from '../../../../__styling/style-functions'
import { calcRem } from '../../../../__styling/style-functions/calc-rem'

export const RestyledPlayIcon = styled(IconPlay)<{ height: number }>(
    ({ height }) => ({
        height: calcRem(height),
        width: calcRem(1.5 * height),
        fill: colors.white,
        paddingRight: calcRem((height * 2) / 3),
    }),
)

export const RestyledKicker = styled(StyledKicker)<{
    iconHeight: number
}>(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    top: 'auto',
    bottom: calcRem(6),
    '&:hover, &:active, &:focus': {
        background: themedValue(theme, {
            sevennews: (section) => section.flyoutNav.hoverColour,

            fallback: undefined,
        }),
    },

    [breakpointMax('xs')]: {
        display: 'flex',
    },
}))

export const StyledLive = styled(StyledLiveBubble)({
    marginLeft: calcRem(9),
})

export const StyledDuration = styled('span')<{ iconHeight: number }>(
    ({ iconHeight }) => ({
        paddingLeft: calcRem((iconHeight * 2) / 3),
        fontWeight: 400,
        minWidth: '2.5em',
    }),
)
